import { useEffect, useState } from "react";
import SanitizedHTML from "react-sanitized-html";
import { FormCheck } from "react-bootstrap";

import FormNavigation from "forms/donor-schedule/navigation.component";

const DonationGuidelines = ({
  settingsLoaded,
  fetchSettings,
  donationGuidelines,
  previousStep,
  nextStep,
  navigation,
  isRequire,
}) => {
  const [agreed, setAgreed] = useState(false);

  useEffect(() => {
    if (!settingsLoaded) fetchSettings();
  }, []);

  if (!settingsLoaded) return null;

  return (
    <form onSubmit={nextStep}>
      <div className="mb-2">
        <div
          className="mb-4 box p-3"
          style={{ maxHeight: "20em", overflowY: "auto" }}
        >
          <SanitizedHTML html={donationGuidelines} />
        </div>
        <FormCheck
          id="donation-guideline-agreement"
          label="I agree to the donation guidelines"
          checked={agreed}
          onChange={(e) => setAgreed(e.target.checked)}
        />
      </div>
      <FormNavigation previousStep={previousStep} invalid={!agreed} />
    </form>
  );
};

export default DonationGuidelines;
